<form [formGroup]="selectOptionsForm">
  <mat-form-field class="w-100">
    <mat-select [placeholder]="fieldPlaceholder" [required]="isRequired" formControlName="modelOptions" multiple>
      <mat-select-trigger>{{ selectOptionsForm.get('modelOptions').value | checkboxMultiselectPipe: inputOptions }}</mat-select-trigger>
      <mat-option #allSelectionElement (click)="toggleAllSelection()" [value]="0">{{
        selectAllLabel
        }}</mat-option>
      <ng-container *ngFor="let option of inputOptions; trackBy: getIdentifierForIterableItem">
        <mat-option
          *ngIf="option.msoIsVisible"
          [value]="option"
          (click)="toggleOption()">
          {{ option.name ? option.name : option.Description }}
        </mat-option>
      </ng-container>
    </mat-select>
  </mat-form-field>
</form>
